import React from "react";

import SvgActivity from "@uui/Activity";

import { Typography, styled } from "@mui/material";

import Stack, { Row } from "@rui/Stack";

const SettingBox = styled(Row)(({ theme }) => ({
  border: `solid 1px ${theme.palette.shades.neutral[100]}`,
  borderRadius: "8px",
  padding: theme.spacing(1.25),
}));

const IconBox = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.shades.ghost[300],
  borderRadius: "6px",
  minWidth: "36px",
  height: "36px",
  svg: {
    padding: theme.spacing(0.25),
    color: theme.palette.shades.primary[500],
  },
}));

const WorkspaceSetting = ({
  Icon,
  control,
  title,
  description,
  currentSettingLabel,
}: {
  Icon: typeof SvgActivity;
  control: React.ReactNode;
  title: string;
  description: string;
  currentSettingLabel: string;
}) => {
  return (
    <SettingBox variant="apart" spacing={1}>
      <Row variant="apart" spacing={2} width="100%">
        <Row spacing={2} width="100%">
          <IconBox variant="center">
            <Icon />
          </IconBox>
          <Stack spacing={0.5}>
            <Typography variant="bodyPrimaryMed">{title}</Typography>
            <Typography variant="labelReg" sx={{ color: "shades.neutral.500" }}>
              {description}
            </Typography>
          </Stack>
        </Row>
        <Row variant="right" width="100%" spacing={1}>
          <Typography variant="bodyPrimaryReg" textAlign="right">
            {currentSettingLabel}
          </Typography>
          {control}
        </Row>
      </Row>
    </SettingBox>
  );
};

export default WorkspaceSetting;
